import CrmContact from "../model2/crm/contact/model"

export default class CRMModalsManager {

    showSearch(type: 'account' | 'contact', accountId: ID | null, contactIds: ID[] | null, callback?: (crmAccountId: ID, crmContactIds: ID[])=>void) {
        gd.modal.showV4({
            className   : 'modal-crm-search',
            component   : require('./crm/search/search'),
            params      : {
                type        : type,
                accountId   : accountId,    // for 'contact' type
                contactIds  : contactIds,   // for 'contact' type
                onSubmit    : (crmAccountId: ID, crmContactIds: ID[])=>{
                    if (callback) {
                        callback(crmAccountId, crmContactIds)
                    }
                    gd.modal.hide()

                    return
                },
            }
        })
    }

    inviteContact(contact: CrmContact, callback?: ()=>void) {
        gd.modal.showV4({
            className   : 'modal-crm-invite',
            component   : require('./crm/invite/invite'),
            params      : {
                contact     : contact,
                onSubmit    : (result: {email: string})=>{

                    const invite = ()=>{
                        gd.api.CRM.inviteContact(contact.id).done(()=>{
                            if (callback) {
                                callback()
                            }
                            gd.modal.hide()

                            return
                        })

                        return
                    }

                    if (contact.email !== result.email) {
                        contact.email = result.email
                        contact.save().done(()=>{
                            invite()

                            return
                        })
                    }
                    else {
                        invite()
                    }

                    return
                },
            }
        })
    }
}
